import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../content/data';

const Ctx = createContext({ overrides: {}, settings: {}, links: [], ct: (k, f) => f, ctList: (k, f) => f });
export const useContent = () => useContext(Ctx);

export function ContentProvider({ children }) {
  const [state, setState] = useState({ overrides: {}, settings: {}, links: [] });

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/content/overrides`).catch(() => ({ data: {} })),
      axios.get(`${API}/settings`).catch(() => ({ data: {} })),
      axios.get(`${API}/links`).catch(() => ({ data: [] })),
    ]).then(([o, s, l]) => {
      setState({ overrides: o.data || {}, settings: s.data || {}, links: Array.isArray(l.data) ? l.data : [] });
    });
  }, []);

  const ct = (key, fallback) => state.overrides[key] ?? fallback;
  const ctList = (key, fallback) => {
    const raw = state.overrides[key];
    if (!raw) return fallback;
    try {
      const v = JSON.parse(raw);
      return Array.isArray(v) ? v : fallback;
    } catch {
      return fallback;
    }
  };
  return <Ctx.Provider value={{ ...state, ct, ctList }}>{children}</Ctx.Provider>;
}
